import { lazy } from "react";

export const CreateUserAsync = lazy(() => import("./CreateUser"));
